import { SelectionChangedEvent } from "ag-grid-community";
import { CounterCustomerChargeEntity } from "domain/entity/CounterCustomerCharge/CounterCustomerChargeEntity";
import { INITIAL_COUNTER_CUSTOMER_CHARGE_COL_DEF_OICT, INITIAL_COUNTER_CUSTOMER_CHARGE_COL_DEF_RSCT, INITIAL_COUNTER_CUSTOMER_CHARGE_COL_DEF_SAPT, transferRowData } from "presentation/constant/CounterCustomerCharge/CounterCustomerChargeMaintenanceColumnDefinition";
import { useCounterCustomerChargeMaintenanceVM } from "presentation/hook/CounterCustomerCharge/useCounterCustomerChargeMaintenanceVM";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useCounterCustomerChargeMaintenanceTracked } from "presentation/store/CounterCustomerCharge/CounterCustomerChargeMaintenanceProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Loader } from "veronica-ui-component/dist/component/core";


const CounterCustomerChargeTablePanel: React.FC = () => {
    const [counterCustomerChargeState] = useCounterCustomerChargeMaintenanceTracked();
    const counterCustomerChargeVM = useCounterCustomerChargeMaintenanceVM();
    const gridRef: any = useRef(null);
    const { tableData, isLoading, editWaiverList, suppleWaiverList, isShowAdditionalChargePanel, isShowWaiverReasonCodePanel, isShowBillToCompanyPanel, isShowChargeOnCompanyPanel,
        isShowInvoiceInfoPanel, isShowPaidThroughDatePanel, isShowSuppleWaiverPanel, isShowPaymentModePanel, isShowAdjustmentPanel, isShowChargeQtyPanel,
        isShowExtraLaborPanel, isShowAccTerminalPanel, isShowStuffingPanel, isShowAgentDeliveryDatePanel, isShowExtensionPaymentPanel } = counterCustomerChargeState;
    const [anainfoState] = useANAInfoTracked();
    const { operatingUnit } = anainfoState;
    const [showOverlay, setShowOverlay] = useState<boolean>(false);

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();

        counterCustomerChargeVM.updateSelectedRows(selectedRows, operatingUnit, editWaiverList, suppleWaiverList);
    }, [counterCustomerChargeVM, operatingUnit, editWaiverList, suppleWaiverList])

    const handleRowDoubleClick = useCallback((entity: CounterCustomerChargeEntity) => {
        counterCustomerChargeVM.onEdit(entity);
    }, [counterCustomerChargeVM]);

    useEffect(() => {
        setShowOverlay(isLoading || (!isLoading && tableData && tableData.length) ? false : true);

        if (gridRef.current?.gridRef.current &&
            !isLoading &&
            gridRef.current?.gridRef.current?.api?.getSelectedNodes()?.length > 0) {
            gridRef.current?.gridRef.current?.api?.getSelectedNodes()?.forEach((node: any) => {
                node.setSelected(false);
            });
        }
    }, [isLoading, tableData]);

    const isRowSelectable = useCallback(() => {
        if (isShowAdditionalChargePanel || isShowBillToCompanyPanel || isShowChargeOnCompanyPanel
            || isShowInvoiceInfoPanel || isShowPaidThroughDatePanel || isShowWaiverReasonCodePanel
            || isShowSuppleWaiverPanel || isShowAdjustmentPanel || isShowChargeQtyPanel || isShowExtraLaborPanel
            || isShowAccTerminalPanel || isShowStuffingPanel || isShowAgentDeliveryDatePanel || isShowExtensionPaymentPanel || isShowPaymentModePanel) {
            return false;
        } else {
            return true;
        }
    }, [isShowAccTerminalPanel, isShowAdditionalChargePanel, isShowAdjustmentPanel, isShowAgentDeliveryDatePanel, isShowBillToCompanyPanel, isShowChargeOnCompanyPanel, isShowChargeQtyPanel, isShowExtensionPaymentPanel, isShowExtraLaborPanel, isShowInvoiceInfoPanel, isShowPaidThroughDatePanel, isShowPaymentModePanel, isShowStuffingPanel, isShowSuppleWaiverPanel, isShowWaiverReasonCodePanel]);

    /*useEffect(() => {
        const handleRightClickMenu = (event: any) => {
            if (_.isEmpty(selectedRows) || !allowUpdate) {
                return;
            }
            event.preventDefault();
            rightClickRef.current.show(event);
        };
        document.getElementById('myDiv')?.addEventListener("contextmenu", handleRightClickMenu);

        return () => {
            document.getElementById('myDiv')?.removeEventListener("contextmenu", handleRightClickMenu);
        };
    }, [messageBarVM, rightClickRef, allowUpdate, selectedRows])*/

    const memoCounterCusomerTable = useMemo(() => {
        return (
            <NbisTable
                id='tariff-code-table'
                isNewColumnSetting={true}
                columns={((operatingUnit === 'SAPT' || operatingUnit === 'KICT') ? INITIAL_COUNTER_CUSTOMER_CHARGE_COL_DEF_SAPT
                    : ((operatingUnit === 'AQCT' || operatingUnit === 'RSCT') ? INITIAL_COUNTER_CUSTOMER_CHARGE_COL_DEF_RSCT
                        : INITIAL_COUNTER_CUSTOMER_CHARGE_COL_DEF_OICT))}
                data={transferRowData(tableData ?? [])}
                showPaginator={false}
                editable={false}
                showAddIcon={false}
                showDeleteButton={false}
                showReloadIcon={false}
                isScrollHighlighted={true}
                selectionMode={false}
                rowSelection={"multiple"}
                isRowHighligted={true}
                handleSelectionChanged={handleSelectionChange}
                onRowDoubleClick={(e: any, entity: CounterCustomerChargeEntity) => handleRowDoubleClick(entity)}
                gridHeight="customHeight"
                customHeight="calc(100vh - 130px)"
                ref={gridRef}
                showDefaultOverlayNoRowsTemplate={showOverlay}
                handleRowSelectable={isRowSelectable}
            />
        );
    }, [operatingUnit, tableData, handleSelectionChange, showOverlay, isRowSelectable, handleRowDoubleClick])

    useEffect(() => {
        if (gridRef.current && gridRef.current.gridRef && gridRef.current.gridRef.current && gridRef.current.gridRef.current.api) {

            gridRef.current.gridRef.current.api.redrawRows();
        }
    }, [isShowAccTerminalPanel, isShowAdditionalChargePanel, isShowAdjustmentPanel, isShowAgentDeliveryDatePanel, isShowBillToCompanyPanel, isShowChargeOnCompanyPanel, isShowChargeQtyPanel, isShowExtensionPaymentPanel, isShowExtraLaborPanel, isShowInvoiceInfoPanel, isShowPaidThroughDatePanel, isShowPaymentModePanel, isShowStuffingPanel, isShowSuppleWaiverPanel, isShowWaiverReasonCodePanel])

    return <><TableWrapper>
        {(isLoading) && <Loader Indicator="Spinner" size="Medium" />}
        {memoCounterCusomerTable}
    </TableWrapper>
    </>;
}

export default memo(CounterCustomerChargeTablePanel);
